module.exports = __webpack_public_path__ + "8859082DD4A154ECB2EBD04ACD88B0FBtb2.f75d9c2c.png";